(function () {
  function getSlidesOffset(slider) {
    if (window.innerWidth < 750) return 20;

    var slide = slider.querySelector('.landing-testimonials__slide');
    var slideWidth = slide ? slide.getBoundingClientRect().width : 412;
    var spaceBetween = 32;
    var visibleGroupWidth = slideWidth * 2 + spaceBetween;

    return Math.max(0, (slider.clientWidth - visibleGroupWidth) / 2);
  }

  function initLandingTestimonials(container) {
    if (!container) return;

    var slider = container.querySelector('.landing-testimonials__slider');
    if (!slider || typeof Swiper === 'undefined') return;
    if (slider.swiper) return;

    // Собираем оригинальные слайды ДО инициализации Swiper
    var wrapper = slider.querySelector('.landing-testimonials__wrapper');
    var originalSlides = Array.from(wrapper.querySelectorAll('.landing-testimonials__slide'));
    var originalCount = originalSlides.length;

    // Нужно минимум ~12 слайдов для loop + slidesPerView:auto
    var minSlides = 12;
    while (wrapper.querySelectorAll('.landing-testimonials__slide').length < minSlides) {
      originalSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-cloned-testimonial', 'true');
        wrapper.appendChild(clone);
      });
    }

    // Считаем offset ПОСЛЕ того как слайды в DOM, но используем RAF
    // чтобы браузер успел посчитать layout
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var offset = getSlidesOffset(slider);

        new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 32,
          centeredSlides: false,
          loop: true,
          loopAdditionalSlides: 4,
          speed: 500,
          grabCursor: true,
          watchOverflow: false,

          slidesOffsetBefore: offset,
          slidesOffsetAfter: offset,

          navigation: {
            nextEl: container.querySelector('.landing-testimonials__arrow--next'),
            prevEl: container.querySelector('.landing-testimonials__arrow--prev'),
          },

          breakpoints: {
            0: {
              spaceBetween: 32,
              slidesOffsetBefore: 20,
              slidesOffsetAfter: 20,
            },
            750: {
              spaceBetween: 32,
              slidesOffsetBefore: offset,
              slidesOffsetAfter: offset,
            },
          },

          on: {
            resize: function () {
              var newOffset = getSlidesOffset(slider);
              this.params.slidesOffsetBefore = newOffset;
              this.params.slidesOffsetAfter = newOffset;
              if (this.params.breakpoints[750]) {
                this.params.breakpoints[750].slidesOffsetBefore = newOffset;
                this.params.breakpoints[750].slidesOffsetAfter = newOffset;
              }
              this.update();
            },
          },
        });
      });
    });
  }

  function initAllLandingTestimonials() {
    document.querySelectorAll('[data-landing-testimonials]').forEach(initLandingTestimonials);
  }

  document.addEventListener('DOMContentLoaded', initAllLandingTestimonials);

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('[data-landing-testimonials]');
    initLandingTestimonials(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('[data-landing-testimonials]');
    if (!container) return;
    var slider = container.querySelector('.landing-testimonials__slider');
    if (slider && slider.swiper) slider.swiper.destroy(true, true);
  });
})();
